export default __webpack_public_path__ + "static/media/background-grass2.a5b2ee8e.png";